var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.6C3 5.214 3 4.521 3.3123 4.0116C3.4869 3.7263 3.7263 3.4869 4.0116 3.3123C4.5201 3 5.214 3 6.6 3C7.986 3 8.679 3 9.1884 3.3123C9.4737 3.4869 9.7131 3.7263 9.8877 4.0116C10.2 4.5201 10.2 5.214 10.2 6.6C10.2 7.986 10.2 8.679 9.8877 9.1884C9.7131 9.4737 9.4737 9.7131 9.1884 9.8877C8.6799 10.2 7.986 10.2 6.6 10.2C5.214 10.2 4.521 10.2 4.0116 9.8877C3.72651 9.71314 3.48686 9.47349 3.3123 9.1884C3 8.6799 3 7.986 3 6.6Z",
    fill: "#9E3039",
    stroke: "#9E3039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7998 17.4C13.7998 16.014 13.7998 15.321 14.1121 14.8116C14.2867 14.5263 14.5261 14.2869 14.8114 14.1123C15.3199 13.8 16.0138 13.8 17.3998 13.8C18.7858 13.8 19.4788 13.8 19.9891 14.1123C20.2735 14.2869 20.5129 14.5263 20.6875 14.8116C20.9998 15.3201 20.9998 16.014 20.9998 17.4C20.9998 18.786 20.9998 19.479 20.6875 19.9893C20.5128 20.2738 20.2736 20.5131 19.9891 20.6877C19.4788 21 18.7858 21 17.3998 21C16.0138 21 15.3208 21 14.8114 20.6877C14.5264 20.5134 14.2868 20.2741 14.1121 19.9893C13.7998 19.479 13.7998 18.786 13.7998 17.4Z",
    fill: "#9E3039",
    stroke: "#9E3039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3123 14.8116C3 15.321 3 16.014 3 17.4C3 18.786 3 19.479 3.3123 19.9893C3.48697 20.2741 3.72662 20.5134 4.0116 20.6877C4.521 21 5.214 21 6.59999 21H6.6H6.60001C7.986 21 8.6799 21 9.1884 20.6877C9.4737 20.5131 9.7131 20.2737 9.8877 19.9893C10.2 19.479 10.2 18.786 10.2 17.4C10.2 16.014 10.2 15.3201 9.8877 14.8116C9.7131 14.5263 9.4737 14.2869 9.1884 14.1123C8.679 13.8 7.986 13.8 6.6 13.8C5.214 13.8 4.5201 13.8 4.0116 14.1123C3.7263 14.2869 3.4869 14.5263 3.3123 14.8116Z",
    stroke: "#9E3039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1121 4.0116C13.7998 4.521 13.7998 5.214 13.7998 6.6C13.7998 7.986 13.7998 8.6799 14.1121 9.1884C14.2867 9.47349 14.5263 9.71314 14.8114 9.8877C15.3208 10.2 16.0138 10.2 17.3998 10.2C18.7858 10.2 19.4788 10.2 19.9891 9.8877C20.2735 9.7131 20.5129 9.4737 20.6875 9.1884C20.9998 8.679 20.9998 7.986 20.9998 6.60001V6.6V6.59999C20.9998 5.214 20.9998 4.5201 20.6875 4.0116C20.5129 3.7263 20.2735 3.4869 19.9891 3.3123C19.4788 3 18.7858 3 17.3998 3C16.0138 3 15.3199 3 14.8114 3.3123C14.5261 3.4869 14.2867 3.7263 14.1121 4.0116Z",
    stroke: "#9E3039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIconActive);
export default __webpack_public_path__ + "static/media/manual_icon_active.e430d54d7fea97fe6700324fc63c34b0.svg";
export { ForwardRef as ReactComponent };